import React from 'react';
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  IconButton,
} from '@mui/material';

const PatientTable = ({
  patients,
  onEditClick,
  onDeleteClick,
  onPatientClinicalView,
  onExaminePatient,
}) => {
  return (
    <TableContainer component={Paper}>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>ID</TableCell>
            <TableCell>Patient ID</TableCell>
            <TableCell>Aadhaar Number</TableCell>
            <TableCell>First Name</TableCell>
            <TableCell>Last Name</TableCell>
            <TableCell>Email</TableCell>
            <TableCell>Phone Number</TableCell>
            <TableCell>Actions</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {patients.map((patient, index) => (
            <TableRow key={index}>
              <TableCell>{patient.id}</TableCell>
              <TableCell>{patient.upid}</TableCell>
              <TableCell>{patient.adharNumber}</TableCell>
              <TableCell>{patient.firstName}</TableCell>
              <TableCell>{patient.lastName}</TableCell>
              <TableCell>{patient.email}</TableCell>
              <TableCell>+{patient.phone}</TableCell>
              <TableCell style={{ padding: '5px' }}>
                {onEditClick && (
                  <IconButton
                    sx={{ color: '#007bff' }}
                    onClick={(event) => onEditClick(event, patient.id)}
                  >
                    <i className="fa fa-pencil"></i>
                  </IconButton>
                )}
                {onDeleteClick && (
                  <IconButton
                    sx={{ color: '#dc3545' }}
                    onClick={() => onDeleteClick(patient.id)}
                  >
                    <i className="fa fa-trash-o"></i>
                  </IconButton>
                )}
                {onPatientClinicalView && (
                  <IconButton onClick={() => onPatientClinicalView(patient.id)}>
                    <i className="fa fa-trash-o"></i>
                  </IconButton>
                )}
                {onExaminePatient && (
                  <IconButton
                    onClick={(event) => onExaminePatient(event, patient.id)}
                  >
                    <i className="fa fa-chevron-circle-right"></i>
                  </IconButton>
                )}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default PatientTable;
